module.exports = __webpack_public_path__ + "img/nordvpn-vs-expressvpn-cover.1c8430a5.png";